import React, { FC, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AlertBubbleIcon } from '@shopify/polaris-icons';
import { Navigation } from '@shopify/polaris';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import Grid from '@mui/material/Grid';

import { NavigationContext } from '../../../adminModules/navigation/contexts/NavigationContext';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const BackflowSidebar: FC = () => {
  const location = useLocation();

  const { user } = useContext(AuthenticationContext);
  const { badgeDisplayValues, badgeCountsErrorMessage, fetchBadgeCounts, badgeCountsLoading } =
    useContext(NavigationContext);

  const isApprover = user?.modules?.some((module) => module.value === 'backflow_testing' && module.can_review);
  const isAdminUser = user?.modules?.some((module) => module.value === 'backflow_testing' && parseInt(module.tier) > 2);

  const hasAdminAccess = isAdminUser || isApprover;
  const navigationItems = [];

  useEffect(() => {
    fetchBadgeCounts('backflows');
  }, []);

  if (hasAdminAccess) {
    navigationItems.push({
      label: 'Admin Backflow Testing',
      url: '/backflow_tests/search',
      icon: AlertBubbleIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/backflow_tests/search',
          disabled: false,
          label: 'Backflow Tests',
          badge: badgeDisplayValues?.unstarted_backflow_orders,
        },
        {
          url: '/backflow_tests/approvals',
          disabled: false,
          label: 'Approval Queue',
          badge: badgeDisplayValues?.approval_queue_orders,
        },
        {
          url: '/backflow_tests/water_authority_submissions',
          disabled: false,
          label: 'Water Authority Tracking',
        },
        {
          url: '/backflow_tests/flagged_devices',
          disabled: false,
          label: 'Flagged Devices',
          badge: badgeDisplayValues?.flagged_devices,
        },
        {
          url: '/backflow_tests/issue_reports?default_type=BackflowJobItem',
          disabled: false,
          label: 'Issue Reports',
        },
      ],
    });
    navigationItems.push({
      label: 'Module Settings',
      url: '/backflow_tests/water_authority_configurations',
      icon: AlertBubbleIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/backflow_tests/water_authority_configurations',
          disabled: false,
          label: 'Water Authority Config',
        },
        {
          url: '/backflow_tests/plumber_config',
          disabled: false,
          label: 'Plumber Config',
        },
        {
          url: '/backflow_tests/servman_sql_logs',
          disabled: false,
          label: 'Servman Logs',
        },
      ],
    });
  } else if (isApprover) {
    navigationItems.push({
      label: 'Backflow Testing',
      url: '/backflow_tests/search',
      icon: AlertBubbleIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/backflow_tests/search',
          disabled: false,
          label: 'Scheduled Backflow Tests',
        },
        {
          url: '/backflow_tests/search',
          disabled: false,
          label: 'Unscheduled Backflow Tests',
        },
        {
          url: '/backflow_tests/approvals',
          disabled: false,
          label: 'Approval Queue',
        },
      ],
    });
  } else {
    navigationItems.push({
      label: 'Backflow Testing',
      url: '/backflow_tests/search',
      icon: AlertBubbleIcon as any,
      matches: true,
      subNavigationItems: [
        {
          url: '/backflow_tests/search',
          disabled: false,
          label: 'Backflow Tests',
        },
      ],
    });
  }

  return (
    !badgeCountsLoading && (
      <Grid container>
        <Grid item xs={12}>
          <Navigation location={location.pathname}>
            <Navigation.Section items={navigationItems} />
          </Navigation>
        </Grid>
        <Grid item xs={12}>
          <ErrorMessage message={badgeCountsErrorMessage} />
        </Grid>
      </Grid>
    )
  );
};

export default BackflowSidebar;
